var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"proposal-list-item",on:{"click":function($event){return _vm.clickHandler()}}},[_c('proposal-card',{attrs:{"proposal":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }